import styled from "@emotion/styled";

export const PageContent = styled.div`
  margin: auto;
`;
